import { useRef, useState } from "react";
import audiobook2 from '../../Assets/Images/audiobook2.png'
import { FaPause, FaPlay } from "react-icons/fa6";

const AudioPlayer = ({ isRead, currentChapter, handleReadChapters }) => {

    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);

    const togglePlayPause = () => {
        if (isPlaying) {
            audioRef.current.pause();
        } else {
            audioRef.current.play();
            handleReadChapters();
        }
        setIsPlaying(!isPlaying);
    };

    console.log("isRead", isRead)

    return (
        <div className="audio-player-container">
            <div className="image-wrapper" onClick={togglePlayPause}>
                <img src={currentChapter?.image_file} alt="Audio Background" className="background-image" />
                <button style={{ background: isRead ? "grey" : "#ff5722" }}
                    className="play-pause-button">
                    {isPlaying ? <FaPause size={22}  /> : <FaPlay  size={22} />}
                </button>
            </div>
            <audio ref={audioRef} src={currentChapter?.audio_file} />
        </div >
    );
};

export default AudioPlayer;
